import axios from '../javascript/custom-axios'

export default { 
  getCurrencies(){
    return axios.get(`currency-type/get`)
  },
}